/* eslint-disable */
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface ExportPDFPayload {
  fields: {
    firstName?: boolean;
    lastName?: boolean;
    email?: boolean;
    role?: boolean;
    organization?: boolean;
    department?: boolean;
    phoneNumber?: boolean;
    employmentType?: boolean;
    consecutiveYearsOfService?: boolean;
  };
}

export interface ExportPDFResponse {
  success: boolean;
  message: string;
  fileUrl?: string;
}

const exportUserPDF = async (
  userId: string,
  payload: ExportPDFPayload
): Promise<Blob> => {
  const response = await customAxios.post(
    `/users/${userId}/export-pdf`,
    payload,
    {
      responseType: "blob",
    }
  );
  return response.data;
};

export const useExportUserPDF = () => {
  return useMutation<
    Blob,
    AxiosError,
    { userId: string; payload: ExportPDFPayload }
  >({
    mutationFn: async ({ userId, payload }) =>
      await exportUserPDF(userId, payload),
    onSuccess: (data) => {
      const blobUrl = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "user-data.pdf";
      link.click();

      showNotification({
        title: "Success",
        message: "PDF exported successfully.",
        color: "green",
      });
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to export PDF",
        color: "red",
      }),
  });
};
